module.exports = __webpack_public_path__ + "img/Manuello_Design.db0e8bed.png";